import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { LayoutDashboard, Building2, FileText, LogOut, CreditCard, Settings, User, Sun, Moon, Link2 } from 'lucide-react';

function NavItem({ to, icon: Icon, label, end }) {
  return (
    <NavLink to={to} end={end} className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
      <Icon size={17} /><span>{label}</span>
    </NavLink>
  );
}

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  return (
    <div className="app-layout">
      <aside className="sidebar">
        <div className="sidebar-logo">
          <img
            src={theme === 'dark' ? '/ainasuite_dark_top.png' : '/logo.png'}
            alt="AinaSuite"
            className="sidebar-logo-desktop"
          />
          <img src="/logos.png" alt="AinaSuite" className="sidebar-logo-mobile" />
        </div>
        <nav className="sidebar-nav">
          <div className="sidebar-section">Management</div>
          <NavItem to="/admin" icon={LayoutDashboard} label="Dashboard" end />
          <NavItem to="/admin/merchants" icon={Building2} label="Merchants" />
          <NavItem to="/admin/plans" icon={CreditCard} label="Plans" />
          <NavItem to="/admin/invoices" icon={FileText} label="Invoices" />
          <NavItem to="/admin/invoice-settings" icon={Settings} label="Invoice Settings" />
          <NavItem to="/admin/connected-apps" icon={Link2} label="Connected Apps" />
          <div className="sidebar-section" style={{ marginTop: 8 }}>Account</div>
          <NavItem to="/admin/my-account" icon={User} label="My Account" />
        </nav>
        <div className="sidebar-footer">
          <button onClick={toggleTheme} className="nav-item" style={{ marginBottom: 8, opacity: 1 }}>
            {theme === 'dark' ? <Sun size={15} /> : <Moon size={15} />}
            <span>{theme === 'dark' ? 'Light Mode' : 'Dark Mode'}</span>
          </button>
          <div className="sidebar-user" onClick={async () => { await logout(); navigate('/login'); }}>
            <div className="avatar avatar-sm" style={{ background: 'var(--red)' }}>SA</div>
            <div className="user-info" style={{ flex: 1 }}>
              <div style={{ fontSize: '0.82rem', fontWeight: 600 }}>{user?.name}</div>
              <div style={{ fontSize: '0.72rem', color: 'var(--red)' }}>Super Admin</div>
            </div>
            <LogOut size={14} color="var(--text-muted)" />
          </div>
        </div>
      </aside>
      <main className="main-content"><Outlet /></main>
    </div>
  );
}
